// ================================================================================
// wp-block-slider.js
// スライダーのスクリプトファイル
// ================================================================================

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

window.addEventListener('load', () => {
	const el = document.querySelector('.js-notice-slider-swiper');
	if (!el) return;

	const inner = el.closest('.wp-block-notice-slider__inner');

	new Swiper(el, {
		modules: [Navigation, Pagination],
		loop: true,
		speed: 500,
		watchOverflow: true,
		updateOnWindowResize: true,
		observer: true,
		observeParents: true,

		spaceBetween: 34,
		slidesPerView: 1.8,
		centeredSlides: true,
		centeredSlidesBounds: false,

		navigation: {
			nextEl: inner ? inner.querySelector('.js-notice-slider-next') : null,
			prevEl: inner ? inner.querySelector('.js-notice-slider-prev') : null,
		},
		pagination: {
			el: el.querySelector('.swiper-pagination'),
			clickable: true,
		},

		breakpoints: {
			782: {
				slidesPerView: 4,
				centeredSlides: false,
				centeredSlidesBounds: false,
			},
		},
	});
});